import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-one',
  templateUrl: './home-one.component.html',
  styleUrls: ['./home-one.component.scss']
})
export class HomeOneComponent implements OnInit {


  sliderImages = [
    'assets/img/home-one/banner1.png',
    'assets/img/home-one/banner2.png',
    'assets/img/home-one/banner3.png',
    'assets/img/home-one/banner4.png',
    'assets/img/home-one/banner5.png'
  ];

  sections = [
    { id: 'section-slider', color: '#FFD700' },
    { id: 'section-legacy', color: '#FFD700' },
    { id: 'section-products', color: '#FFD700' },
    { id: 'section-brands', color: '#FFD700' },
    { id: 'section-recipes', color: '#FFD700' },
    { id: 'section-highlight', color: '#FFD700' }
  ];

  recipes = [
    {
      image: 'assets/img/recipes/recipe-5.png',
      title: 'Ice cream\nsundae',
      description: 'A tempting ice cream creation loaded with treats. The ultimate feel-good dessert.',
      url: '/recipes/Cheese-and-Corn-Samosa'    
    },
    {
      image: 'assets/img/recipes/recipe-2.png',
      title: 'Yogurt-Marinated Barbeque	',
      description: 'Tender barbeque bites marinated in yogurt and spices. A quick, juicy grill favourite.',
      url: '/recipes/Yogurt-Marinated Barbeque'
    },
    {
      image: 'assets/img/recipes/recipe-3.png',
      title: 'Pina Colada Mocktail',
      description: 'A refreshing blend of pineapple and coconut flavours. Light, cool, and perfect for sunny days.',
      url: '/recipes/Pina Colada Mocktail'
    },
    {
      image: 'assets/img/recipes/recipe-1.png',
      title: 'Hyderabadi Biryani Classic',
      description: 'A flavourful rice dish layered with spices. Perfect for special gatherings.',
      url: '/recipes/hyderabadi-biryani'
    }
    
  ];

  autoplaySpeed = 3000;

  constructor() {}

  ngOnInit(): void {}

  scrollTo(id: string) {
    document.getElementById(id)?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }

}
